import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReintegrosService {

  constructor(
    private http: HttpClient
  ) { }

  sendForm(enviarForm: FormData): Observable<any>{
    return this.http.post(`${environment.urlApi}reintegros/sendRefundRequest?sid=` + environment.sessionId, enviarForm);
    
  }   
}
